/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChangePasswordFirstTime200Response
 */
export interface ChangePasswordFirstTime200Response {
    /**
     * 
     * @type {boolean}
     * @memberof ChangePasswordFirstTime200Response
     */
    success?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordFirstTime200Response
     */
    message?: string;
}

/**
 * Check if a given object implements the ChangePasswordFirstTime200Response interface.
 */
export function instanceOfChangePasswordFirstTime200Response(value: object): value is ChangePasswordFirstTime200Response {
    return true;
}

export function ChangePasswordFirstTime200ResponseFromJSON(json: any): ChangePasswordFirstTime200Response {
    return ChangePasswordFirstTime200ResponseFromJSONTyped(json, false);
}

export function ChangePasswordFirstTime200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChangePasswordFirstTime200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'message': json['message'] == null ? undefined : json['message'],
    };
}

export function ChangePasswordFirstTime200ResponseToJSON(json: any): ChangePasswordFirstTime200Response {
    return ChangePasswordFirstTime200ResponseToJSONTyped(json, false);
}

export function ChangePasswordFirstTime200ResponseToJSONTyped(value?: ChangePasswordFirstTime200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
    };
}

